// @flow

import React from 'react';
import ReduxFormField from '../../../../form/reduxFormField';
import { ReduxFormLabeledSelect } from '../../../../form/labeledFields';
import type { Validators } from '../../../../form/reduxFormField';
import getCookie from '../../../../../helpers/cookie/cookie';

type Props = {
  label: string,
  name: string,
  placeholder: string,
  shops: Array<{label: string, value: string}>,
  withValidator: Array<Validators> | Validators,
};

const Referrer = ({
  label,
  name,
  shops,
  placeholder,
  withValidator,
}: Props) => {
  if (!getCookie('shop')) {
    return null;
  }

  return (
    <ReduxFormField
      label={label}
      name={name}
      component={ReduxFormLabeledSelect}
      withValidator={withValidator}
    >
      <option value="" key="referrer">{placeholder}</option>
      {shops
        .map(option => <option value={option.value} key={`referrer-${option.value}`}>{option.label}</option>)}
    </ReduxFormField>
  );
};

export default Referrer;
